import { CircleMinus } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const RemoveCircleIcon = createLucideIcon(CircleMinus);
